// @flow
import classNames from 'classnames/bind';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import buttonStyle from '../../../../../assets/styles/button.scss';
import ButtonGreyBox from '../../../../../elements/ButtonGreyBox/ButtonGreyBox';
import FloatingBottom from '../../../../../elements/FloatingBottom/FloatingBottom';
import { CommaFormat } from '../../../../../elements/Price/Price';
import { Mobile } from '../../../../../utils/responsive';

import type { ForecastType } from '../../api';

import style from './FinalPrice.scss';

type Props = {
  total?: string;
  disabled?: boolean;
  handleClick: (e: Event) => void;
  forecastType: ForecastType;
  // If step is provided (as in DIY mode)
  step?: number;
};

const FinalPrice = (props: Props) => {
  const { forecastType, total, step, disabled, handleClick } = props;
  let buttonLabelIntl = '';
  if (forecastType === 'CLASSIC') {
    buttonLabelIntl = 'newOrder.quote.button.pay';
  } else {
    if (typeof step === 'number') {
      if (step === 1) buttonLabelIntl = 'newOrder.quote.button.continue';
      else if (step === 2) buttonLabelIntl = 'newOrder.quote.button.bought';
    } else {
      buttonLabelIntl = 'newOrder.quote.button.purchase';
    }
  }

  const title = forecastType === 'DIY' ? "newOrder.quote.finalPrice.shippingImportation.title" :
    "newOrder.quote.finalPrice.completeService.title";

  const top = <div className={classNames(style.topWrap, { [style.diy]: props.forecastType === 'DIY' })}>
    <div className={style.textWrap}>
      <FormattedMessage id={title}>{
        txt => <h3>{txt}</h3>
      }</FormattedMessage>
      {forecastType === 'CLASSIC' && <FormattedMessage id="newOrder.quote.finalPrice.subtitle">{
        txt => <span>{txt}</span>
      }</FormattedMessage>}
    </div>
    {!total && <h2>--</h2>}
    {!!total && <h2>$ <CommaFormat price={total}/></h2>}
  </div>;

  return (
    <section className={style.finalPriceWrap}>
      <div className={style.onlyDefault}>
        <ButtonGreyBox buttonIntl={buttonLabelIntl}
                       handleClick={handleClick}
                       disabled={disabled}>{top}</ButtonGreyBox>
      </div>
      <Mobile>
        <FloatingBottom offSetY={96}>
          <div className={style.mobileWrap}>
            {/*{top}*/}
            <FormattedMessage id={buttonLabelIntl}>{
              txt => <button disabled={disabled}
                             onClick={handleClick}
                             className={classNames(buttonStyle.btn, buttonStyle.lightBlue, style.pay)}>{txt}</button>
            }</FormattedMessage>
          </div>
        </FloatingBottom>
      </Mobile>
    </section>
  );
};

FinalPrice.propTypes = {
  total: PropTypes.string,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  forecastType: PropTypes.string.isRequired,
  step: PropTypes.number,
};

export default FinalPrice;



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/components/FinalPrice/FinalPrice.jsx